module.exports = __webpack_public_path__ + "img/pop-logotype-rvb-3@2x.dd24efb8.png";